import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConversionsResidentDocMoveGuard } from './services/conversions-resident-doc-move-guard';
import { ConversionsFeatureComponent } from './conversions-feature.component';
import { ResidentDocMoveComponent } from './components/resident-doc-move/resident-doc-move.component';
import { StartDocTransferComponent } from './components/start-doc-transfer/start-doc-transfer.component';
import { DetailDocTransferComponent } from './components/detail-doc-transfer/detail-doc-transfer.component';
import { StartDetailDocTransferComponent } from './components/start-detail-doc-transfer/start-detail-doc-transfer.component';
import { ProfileSyncGuard } from './services/profile-sync.guard';
import { SnfLegacyListGuard } from './services/snf-legacy-list.guard';
import { ProfileSyncListComponent } from './components/profile-sync/profile-sync-list/profile-sync-list.component';
import { ProfileSyncRunComponent } from './components/profile-sync/profile-sync-run/profile-sync-run.component';
import { ProfileSyncFailedUsersComponent } from './components/profile-sync/profile-sync-failed-users/profile-sync-failed-users.component';
import { SnfLegacyListComponent } from './components/snf-legacy-user-import/snf-legacy-list/snf-legacy-list.component';
import { SnfLegacyUserImportListComponent } from './components/snf-legacy-user-import/snf-legacy-user-import-list/snf-legacy-user-import-list.component';
import { SnfLegacyUserImportFailedComponent } from './components/snf-legacy-user-import/snf-legacy-user-import-failed/snf-legacy-user-import-failed.component';
import {KeycloakUserImportListComponent} from "./components/keycloak-user-import/keycloak-user-import-list/keycloak-user-import-list.component";
import {GroupGuard} from "../shared/group.guard";
import {SecurityService} from "../shared/security.service";
import { KeycloakListComponent } from './components/keycloak-user-import/keycloak-list/keycloak-list.component';
import { KeycloakUserImportFailedComponent } from './components/keycloak-user-import/keycloak-user-import-failed/keycloak-user-import-failed.component';
import { oktaIdmCanActivate } from '../shared/oktaIdmCanActivate';
import { ImportUsersListComponent } from './components/import-users-to-idm/import-users-list/import-users-list.component';
import { ImportListComponent } from './components/import-users-to-idm/import-list/import-list.component';
import { ImportUserFailedComponent } from './components/import-users-to-idm/import-user-failed/import-user-failed.component';


export function onAuthRequired({ oktaAuth, router }) {
  // Redirect the user to your custom login page
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'conversions',
    component: ConversionsFeatureComponent,
    canActivate: [oktaIdmCanActivate],
    data: {
      onAuthRequired
    },
    children: [
      {
        path: 'resident-doc-move',
        component: ResidentDocMoveComponent,
        canActivate: [oktaIdmCanActivate, ConversionsResidentDocMoveGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'resident-doc-move/start',
        component: StartDocTransferComponent,
        canActivate: [oktaIdmCanActivate, ConversionsResidentDocMoveGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'resident-doc-move/detail',
        component: DetailDocTransferComponent,
        canActivate: [oktaIdmCanActivate, ConversionsResidentDocMoveGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'resident-doc-move/start/detail',
        component: StartDetailDocTransferComponent,
        canActivate: [oktaIdmCanActivate, ConversionsResidentDocMoveGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'profile-sync',
        component: ProfileSyncListComponent,
        canActivate: [oktaIdmCanActivate, ProfileSyncGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'profile-sync/run',
        component: ProfileSyncRunComponent,
        canActivate: [oktaIdmCanActivate, ProfileSyncGuard],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'profile-sync/failedUsers/:processId',
        component: ProfileSyncFailedUsersComponent,
        canActivate: [oktaIdmCanActivate, ProfileSyncGuard],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'snf-legacy-user-import-list',
        component: SnfLegacyUserImportListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'snf-legacy-user-import-list/run',
        component: SnfLegacyListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'snf-legacy-user-import-list/failedUsers/:processId',
        component: SnfLegacyUserImportFailedComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      } ,
      {
        path: 'keycloak-user-import-list',
        component: KeycloakUserImportListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'keycloak-user-import-list/run',
        component: KeycloakListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'keycloak-user-import-list/failedUsers/:processId',
        component: KeycloakUserImportFailedComponent,
        canActivate: [oktaIdmCanActivate , SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'import-users-list',
        component: ImportUsersListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'import-users-list/run',
        component: ImportListComponent,
        canActivate: [ oktaIdmCanActivate, SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'import-users-list/failedUsers/:processId',
        component: ImportUserFailedComponent,
        canActivate: [oktaIdmCanActivate , SnfLegacyListGuard ],
        data: {
          onAuthRequired
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConversionsFeatureRoutingModule { }
